// Put your Javascript here - You can use ES2015 Javascript, because we use Webpack with Babel
'use strict';

if (!Element.prototype.matches) {
	Element.prototype.matches =
		Element.prototype.msMatchesSelector ||
		Element.prototype.webkitMatchesSelector;
}

require('./../Sass/visitx.scss');

import InstantChat from './InstantChat';
import VideoPlayer from './VideoPlayer';
import Imprint from './../../../Assets/Js/Imprint';
import * as helper from './../../../Assets/Js/helper';
import * as Events from './Events';
import ButtonHandler from './ButtonHandler';
import SignupHandler from './SignupHandler';

helper.addEventListener(window, 'load', function () {
	let $info = helper.$('#information');
	let instaChat = new InstantChat($info.dataset['counter']);
	let hostVideo = new VideoPlayer(instaChat.random.bind(instaChat));
	let videoElementHost = helper.$('#videoContainerHost');

	helper.addEventListener(window, Events.START_ACTION, () => {
		let show = document.getElementsByClassName('btn-next');
		helper.showAll(show);
		show = document.getElementsByClassName('btn-chat');
		helper.showAll(show);
		show = document.getElementsByClassName('vid-container');
		show[0].style.display = 'flex';

		instaChat.random();

		helper.addEventListener(window, Events.SHOW_NEXT_GIRL, () => {
			instaChat.random();
		});
	});

	helper.addEventListener(window, Events.VIDEO_CHANGED, function (event) {
		hostVideo.load(event.detail.url);
		videoElementHost.dataset['hostname'] = event.detail.name;
		videoElementHost.dataset['uid'] = event.detail.uid;
		videoElementHost.dataset['age'] = event.detail.age;
	});

	new Imprint(document.querySelectorAll('.imprint'));
	new SignupHandler();
	new ButtonHandler(helper.$('#start'), helper.$('#next'), helper.$('#check'), helper.$('#sendbtn'));
});
